import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { Evaluation } from '../models/Evaluation'
import { AppraisalReport } from '../models/Reports'

@Injectable()
export class EvaluationService {
	constructor(private http: HttpClient) {}

	public getEvaluation(evaluation_id: string): Observable<Evaluation> {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/evaluation/${evaluation_id}`, { headers: options }).pipe(
			map(result => {
				return result.content
			})
		)
	}

	public getEvaluations(companyId: string): Observable<Array<Evaluation>> {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/evaluation/all/${companyId}`, { headers: options }).pipe(
			map(result => {
				return result.content
			})
		)
	}

	public saveEvaluation(evaluation: Evaluation): Observable<any> {
		const options: any = this.setHeader()

		return this.http.post<any>(`${PATH}/evaluation/${evaluation.companyId}`, JSON.stringify(evaluation), {
			headers: options
		})
	}

	public updateEvaluationReportArboreal(evaluations: Array<AppraisalReport>): Observable<string> {
		const options: any = this.setHeader()

		return this.http.patch<any>(`${PATH}/appraisal/evaluationReportArboreal`,
		{
			evaluationsReport: evaluations
		},
		{
			headers: options
		}).pipe(
			map(result => {
				return result.message
			})
		)
	}

	public inactiveEvaluation(evaluation_id: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http.delete<any>(`${PATH}/evaluation/${evaluation_id}`, { headers: options })
	}

	private setHeader(): any {
		const headers: any = new HttpHeaders({ 'Content-Type': 'application/json' })
		const options: any = headers

		return options
	}
}
